import { render } from "./question.vue?vue&type=template&id=6ca5fba5&scoped=true"
import script from "./question.js?vue&type=script&lang=js"
export * from "./question.js?vue&type=script&lang=js"

import "./question.vue?vue&type=style&index=0&id=6ca5fba5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca5fba5"]])

export default __exports__